// extracted by mini-css-extract-plugin
export default {"partyTrayGrid":"PartyTray_partyTrayGrid__xZiQn","partyTrayImage":"PartyTray_partyTrayImage__bjrt3","contactButton":"PartyTray_contactButton__u8p8b"};